import templateUrl from './new-app-notice.html'
import './new-app-notice.scss'

const NewAppNoticeComponent = {
  bindings: {

  },
  templateUrl,
  controller: class NewAppNotice {
    constructor (Configuration) {
      'ngInject'
      this._identify = 'NewAppNoticeComponent'
      this.Configuration = Configuration
    }

    get newAppLink () {
      const domain = this.Configuration.CDBL_ENV === 'production' ? 'app.codeable.io' : `${this.Configuration.CDBL_ENV}.codeable.io`
      return `https://${domain}/v2`
    }
  }
}

export default NewAppNoticeComponent
